<template>
    <div class="" style="width: 100%">
        <div class="phone-box">

            <div class="phone-warper">
                <div class="phone-top" @click="handleModule('select', -100)">
                    <div class="title">{{page.title}}</div>
                </div>
            </div>
            <div class="phone-content">
                <div class="phone-warper">
                    <div class="module-item" :class="{on: currentIndex == key }" v-for="(item, key) in items" @click.stop="handleModule('select', key)">
                        <component :is="item.name" :configData="item.styles"></component>
                        <div class="delete-box">
                            <div class="handleType">
                                <div class="iconfont iconshanchu2"
                                     @click.stop="handleModule('delete', key)"></div>
                                <div class="iconfont iconshangyi" :class="key === 0 ? 'on':''"
                                     @click.stop="handleModule('move', key, 1)"></div>
                                <div class="iconfont iconxiayi"
                                     :class="key === items.length -1 ? 'on':''"
                                     @click.stop="handleModule('move', key, 0)"></div>
                            </div>
                        </div>
                        <div class="handle"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Diy from '../components'
    export default {
        name: "index",
        components: {
            ...Diy
        },
        props: {
            page: {
                type: Object,
                default: {}
            },
            items: {
                type: Array,
                default: []
            },
            currentIndex: {
                type: Number,
                default: -1
            }
        },
        methods: {
            // 点击显示相应的配置
            handleModule(op, index, extra) {
                console.log("sssssss")
                this.$emit('handleModule', {
                    op: op,
                    selectIndex: index,
                    extra: extra
                })
            },
        }
    }
</script>

<style scoped lang="less">
.phone-box{
    flex: 1;
    width: 100%;
    /*margin: 0 auto;*/
    height: calc(100%);
    .phone-top {
        width: 100%;
        height: 66px;
        text-align: center;
        background-position: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        .title{
            margin: 0;
            font-size: 14px;
            font-weight: 400;
            white-space: nowrap;
            line-height: 88px;
        }
    }
    .phone-warper{
        width: 375px;
        margin: 0 auto;
        background-color: #fff;
    }
    .phone-content{
        height: 100%;
        overflow-y: auto;
        padding-bottom: 60px;
        .module-item{
            position: relative;
            .delete-box {
                display: none;
                position: absolute;
                left: -2px;
                top: 0;
                width: 375px;
                height: 100%;
                border: 2px dashed #1890ff;
                z-index: 999;
            }
        }
        .module-item.on{
            cursor: move;
            .delete-box{
                display: block;
                border: 2px solid #1890ff;
                box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3);
                .handleType {
                    position: absolute;
                    right: -43px;
                    top: 0;
                    width: 36px;
                    height: 143px;
                    border-radius: 4px;
                    background-color: #1890ff;
                    cursor: pointer;
                    color: #fff;
                    font-weight: bold;
                    text-align: center;
                    padding: 4px 0;
                    .iconfont {
                        padding: 5px 0;
                    }
                }
            }
        }
    }
    .phone-content::-webkit-scrollbar{
        display:none
    }
}
</style>
